import React, { useState, useContext, createContext, useEffect } from "react";
import axios from 'axios';

const AdminSettingsContext = React.createContext();

const ProvideAdminSettings = (props) => {
    const adminsettings = useProvideAdminSettings();
    return (
        <AdminSettingsContext.Provider value={adminsettings}>
            {props.children}
        </AdminSettingsContext.Provider>
    );
}
function useProvideAdminSettings() {
    const [adminRoles, setAdminRoles] = useState([]);
    const [institutions, setInstitutions] = useState([]);
    const [appURL, setAppURL] = useState('');
    const [modules, setModules] = useState([]);

    const refreshInstitutions = () => {
        axios.get("api/institution/list", {}, { withCredentials: true }).then(response => {
            setInstitutions(response.data.data);
        }).catch(() => {
            setInstitutions([]);
        });
    }
    useEffect(() => {
        axios.get("api/util/adminroles", {}, { withCredentials: true }).then(response => {
            setAdminRoles(response.data);
        }).catch(() => {
            setAdminRoles([]);
        });
        axios.get("api/util/appurl", {}, { withCredentials: true }).then(response => {
            setAppURL(response.data);
        }).catch(() => {
            setAppURL('');
        });
        axios.get("api/module/all", {}, { withCredentials: true }).then(response => {
            setModules(response.data);
        }).catch(() => {
            setModules([]);
        });
        axios.get("api/institution/list", {}, { withCredentials: true }).then(response => {
            setInstitutions(response.data.data);
        }).catch(() => {
            setInstitutions([]);
        });
    }, []);
   
    return { adminRoles, institutions, appURL, modules, refreshInstitutions};
}
function useAdminSettings() {
    return useContext(AdminSettingsContext);

}

export default useAdminSettings;
export { ProvideAdminSettings };